/**
 * T558 — the barrido itself, as a node.
 *
 * Render it as the last child of a control that carries `.nav-pending`. It is decorative
 * and absolutely positioned, so it changes no layout and is hidden from assistive tech —
 * the announcement is the control's own `aria-busy`.
 *
 * It is a real element rather than a `::after` on purpose; `app/styles/app.css` carries the
 * measurement that forced it (a surface that already claims `::after` wins the cascade and
 * the sweep silently renders 1px tall).
 */
export function NavPendingSweep() {
  return <span className="nav-pending-sweep" aria-hidden="true" />;
}
